import * as _groupBy from 'lodash/groupBy';

export function groupBy(array: any[], propertyName: string) {
    return _groupBy(array, propertyName);
}
